import { render, staticRenderFns } from "./CommentExercise.vue?vue&type=template&id=705e621c&scoped=true&"
import script from "./CommentExercise.vue?vue&type=script&lang=js&"
export * from "./CommentExercise.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "705e621c",
  null
  
)

export default component.exports